export default "__VITE_ASSET__Bj8PG_4z__"